import { Divider } from 'antd';
import styled from 'styled-components';

export const StyledDivider = styled(Divider)`
  margin: 16px 0;
`;
